import React, { Fragment } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { makeUniqueKey } from './helper'



const PricingDetails = (props) => {
  const { selectedItem, organization_merch } = props
  const item = selectedItem || {}
  const priceBreakdown = item.price_breakdown || {}
  const merch = item.merch || {}
  const plan = item.plan || {}
  const plans = item.plans || {}
  const programs = Array.isArray(item.programs) ? item.programs : []
  const merchItems = Array.isArray(organization_merch) ? organization_merch : []
  var EF3 = !Object.prototype.hasOwnProperty.call(item, 'programs')
  return (
    <Fragment>
      <Row className="form-group">
        {
          EF3 ?
          <Fragment>
            <Col sm={8}>
              {item.program && item.program.group_name || 'Transaction'} {item.team_name&& `[ ${item.team_name} ]`} ({plan.plan_name || 'Plan'})
            </Col>
            <Col sm={4} className="price">$ {priceBreakdown.plan_price || plan.plan_price || 0}</Col>
          </Fragment>
          :
          <Fragment>
            {
              programs.map(program => {
                const programPlan = plans[program._id] || {}
                return <Fragment>
                  <Col sm={8}>
                  {program.name}
                </Col>
              <Col sm={4} className="price">$ {programPlan.plan_price || 0}</Col>
                </Fragment>
              })
            }
          </Fragment>
        }
      </Row>
      {
        EF3 && priceBreakdown.membership_fee !== 0 &&
        <Row className="form-group">
          <Col sm={8}>Additional Fee</Col>
          <Col sm={4} className="price">$ {priceBreakdown.membership_fee || 0}</Col>
        </Row>
      }
      {
        EF3 && merch.item_0 &&
        <Row className="form-group">
          <Col sm={8}>{merchItems[0] && merchItems[0].name}</Col>
          <Col sm={4} className="price">$ {priceBreakdown.item_0_cost || 0}</Col>
        </Row>
      }
      {
        EF3 && merch.item_1 &&
        <Row className="form-group">
          <Col sm={8}>{merchItems[1] && merchItems[1].name}</Col>
          <Col sm={4} className="price">$ {priceBreakdown.item_1_cost || 0}</Col>
        </Row>
      }
      {
        EF3 && merch.item_2 &&
        <Row className="form-group">
          <Col sm={8}>{merchItems[2] && merchItems[2].name}</Col>
          <Col sm={4} className="price">$ {priceBreakdown.item_2_cost || 0}</Col>
        </Row>
      }
      {
        selectedItem.price_breakdown.extra_fees &&
        selectedItem.price_breakdown.extra_fees.map(fee => {
          for (var extra in fee) {
            return <Row key={makeUniqueKey()} className="form-group">
              <Col sm={8}>{extra.split('_').join(' ').toLowerCase().split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ')}</Col>
              <Col sm={4} className="price">$ {fee[extra]}</Col>
            </Row>
          }
        })
      }
      <Row className="form-group">
        <Col sm={8}>Subtotal</Col>
        <Col sm={4} className="price">$&nbsp;
        {
          EF3 ?
            renderSubtotal(selectedItem,selectedItem.price_breakdown.plan_price, selectedItem.price_breakdown.item_0_cost, selectedItem.price_breakdown.item_1_cost, selectedItem.price_breakdown.item_2_cost, selectedItem.price_breakdown.membership_fee)
          :
          selectedItem.price_breakdown.total
        }
      </Col>
      </Row>
      <hr/>
      {
        selectedItem.price_breakdown.promo_code_applied || selectedItem.price_breakdown.promo_code_applied &&
        <Row className="form-group">
          <Col sm={8}>Discounts</Col>
        </Row>
      }
      {
        selectedItem.price_breakdown.early_bird_applied &&
          <Row className="form-group">
            <Col sm={8}>Early Bird</Col>
            <Col sm={4} className="price"> - {selectedItem.price_breakdown.early_bird}</Col>
          </Row>
      }
      {
        selectedItem.price_breakdown.promo_code_applied &&
        <Row className="form-group">
          <Col sm={8}>Promo Code</Col>
          <Col sm={4} className="price"> - {selectedItem.price_breakdown.promo_code}</Col>
        </Row>
      }
      {
        !selectedItem.price_breakdown.promo_code_applied && !selectedItem.price_breakdown.promo_code_applied &&
        <Row className="form-group">
          <Col sm={8}>Discounts</Col>
          <Col sm={4} className="price">N/A</Col>
        </Row>
      }
    <hr/>
    <Row className="form-group">
      <Col sm={8}>Transaction Total</Col>
      <Col sm={4} className="price">$ {selectedItem.price_breakdown.total}</Col>
    </Row>
    {
      selectedItem.price_breakdown.instalment_number && selectedItem.price_breakdown.instalment_number > 1 &&
      <Row className="form-group">
        <Col sm={8}>{selectedItem.price_breakdown.instalment_number} Instalments</Col>
        <Col sm={4} className="price">$ {selectedItem.price_breakdown.instalment_total}</Col>
      </Row>
    }
    <Row>
      <Button className="resend-receipt" bsStyle="primary" onClick={()=> props.sendEnrolNotification({selectedItem})}>
        Resend Receipt
      </Button>
    </Row>
    </Fragment>
  )
}

const renderSubtotal = (selectedItem, plan, shirt, shorts, hood, additional) => {
  var subTotal = plan + shirt + shorts + hood + additional
  if (selectedItem.price_breakdown.extra_fees) {
    selectedItem.price_breakdown.extra_fees.forEach(fee => {
      for (var extra in fee) {
        subTotal += fee[extra]
      }
    })
  }
  if (subTotal % 1 === 0) {
    return subTotal
  } else {
    return +(subTotal.toFixed(2))
  }
  
}

export default PricingDetails
